<template>
  <div class="text-center">
    <v-menu
      v-if="$vuetify.breakpoint.mdAndUp"
      ref="popover"
      :value="visible"
      @input="$emit('input', $event)"
      :close-on-click="false"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      :position-x="positionX"
      :position-y="positionY"
    >
      <v-list class="pr-9" style="position: relative;">
        <v-btn
          icon
          @click.stop="$emit('input', false)"
          :style="{
            position: 'absolute',
            top: '8px',
            right: 0,
          }"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <template v-for="(action, idx) in shareActions">
          <component :is="action" :item="item" :key="idx" @input="actionDone($event)" />
        </template>
      </v-list>
    </v-menu>

    <v-bottom-sheet
      v-else
      :value="visible"
      @input="$emit('input', $event)"
      inset
      :width="$vuetify.breakpoint.smAndDown ? '100%' : '400'"
    >
      <v-sheet
        class="text-center"
        rounded
      >
        <v-btn
          class="mt-2"
          text
          @click="$emit('input', false)"
        >
          {{ $t('components.share.title') }}
        </v-btn>

        <v-list class="px-4">
          <template v-for="(action, idx) in shareActions">
            <component :is="action" :item="item" :key="idx" @input="actionDone($event)" />
          </template>
        </v-list>
      </v-sheet>
    </v-bottom-sheet>

    <v-snackbar
      v-model="snackbar"
      :timeout="3000"
      top
      class="text-center"
    >
      {{ snackbarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ShareActions from '@/components/share-actions';

export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    item: Object,
    types: {
      type: Array,
      default: () => ['clipboard', 'mail'],
    },
    positionX: Number,
    positionY: Number,
  },
  data: () => ({
    snackbar: false,
    snackbarMessage: null,
  }),
  computed: {
    ...mapState({
      user: ({ session }) => session.session.user,
    }),
    shareActions() {
      return this.types
        .filter((type) => ShareActions[type] != null)
        .map((type) => ShareActions[type]);
    },
  },
  methods: {
    actionDone(data = {}) {
      this.$emit('input', false); // emit false to close actions dialog
      if (typeof data.snackbar === 'string') { // optionally an action could send a snackbar message to display smt
        this.snackbarMessage = data.snackbar;
        this.snackbar = true;
      }
    },
  },
  created() {
    const phoneNumber = this.user.mobilePhone;
    if (phoneNumber !== undefined && phoneNumber !== null && phoneNumber !== '') {
      this.types.push('mobile');
    }
    if (this.user.isWhatsappAllowed === '201') {
      this.types.push('whatsapp');
    }
  },
};
</script>
